import { ContextualField } from '@models/ContextualField';
import { PropertyType } from '../../../models/enum';

export const IsBoundToGroup: ContextualField = {
    extraData: {},
    icon: 'fa-anchor',
    label: 'Bind',
    modelName: 'isBoundToGroup',
    placeholder: 'Bind',
    propertyName: 'isBoundToGroupProperty',
    propertyType: PropertyType.Boolean,
    required: false
};